import WarehouseSyncBucketConfiguration from 'cio/components/warehouse-sync/bucket-configuration';
import WarehouseSyncCreate from 'cio/components/warehouse-sync/create';
import isValidUrl from 'cio/utils/validators/url';
import { IntegrationIDs } from 'cio/utils/integrations/static-integrations';

enum WarehouseValidationMessage {
  blank = "can't be blank",
  json = 'must be valid JSON',
  url = 'must be a valid URL',
}

export const S3ConfigValidations = {
  bucketName(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },

  accessKey(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },

  secretKey(this: WarehouseSyncCreate | WarehouseSyncBucketConfiguration, value: string): string | true {
    if (!value || value?.trim() === '') {
      return this instanceof WarehouseSyncBucketConfiguration
        ? 'Please enter your secret key again to update the S3 bucket configuration'
        : WarehouseValidationMessage.blank;
    }

    return true;
  },

  region(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },
};

export const GCSConfigValidations = {
  bucketName(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },

  credentials(this: WarehouseSyncCreate | WarehouseSyncBucketConfiguration, value: string): string | true {
    if (!value || value?.trim() === '') {
      return this instanceof WarehouseSyncBucketConfiguration
        ? 'Please enter your service account key again to update the GCS bucket configuration'
        : WarehouseValidationMessage.blank;
    }

    try {
      JSON.parse(value);
    } catch (err) {
      return WarehouseValidationMessage.json;
    }

    return true;
  },
};

export const AzureBlobConfigValidations = {
  containerSasUrl(this: WarehouseSyncCreate | WarehouseSyncBucketConfiguration, value: string): string | true {
    if (!value || value?.trim() === '') {
      return this instanceof WarehouseSyncBucketConfiguration
        ? 'Please enter your shared access token again to update the Azure blob configuration'
        : WarehouseValidationMessage.blank;
    }

    if (!isValidUrl(value)) {
      return WarehouseValidationMessage.url;
    }

    return true;
  },
};

export const YandexConfigValidations = {
  bucketName(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },

  accessKey(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },

  secretKey(this: WarehouseSyncCreate | WarehouseSyncBucketConfiguration, value: string): string | true {
    if (!value || value?.trim() === '') {
      return this instanceof WarehouseSyncBucketConfiguration
        ? 'Please enter your secret key again to update the Yandex bucket configuration'
        : WarehouseValidationMessage.blank;
    }

    return true;
  },

  region(value?: string): string | true {
    if (!value || value?.trim() === '') {
      return WarehouseValidationMessage.blank;
    }

    return true;
  },
};

export const WarehouseValidations = {
  [IntegrationIDs.azureBlob]: AzureBlobConfigValidations,
  [IntegrationIDs.gcs]: GCSConfigValidations,
  s3: S3ConfigValidations,
  [IntegrationIDs.yandex]: YandexConfigValidations,
};
